import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import './CreateAccountScene.scss';
import UserRole from 'scenes/V3/CreateAccountScene/UserRole';
import CreateEventLandingPage from 'scenes/V3/CreateEventLandingPage';
import AthleticTrainerSignUp from '../SignUp/AthleticTrainer/AthleticTrainerSignUp';
import NextSteps from 'scenes/V3/CreateAccountScene/NextSteps';
import OrganizationType from 'scenes/V3/CreateAccountScene/OrganizationType';
import OrganizationDetails from 'scenes/V3/CreateAccountScene/OrganizationDetails';  // ← NOU
import SignUp from 'scenes/V3/CreateAccountScene/SignUp';
import Persona from 'scenes/V3/CreateAccountScene/Persona';

class CreateAccountScene extends Component {
  renderRoute = (route, Component) => {
    const { match } = this.props;
    return <Route exact path={`${match.url}/${route}`} render={props => <Component {...props} />} />;
  };

  render() {
    return (
      <div className="v2CreateAccountScene">
        <main className="content gotham-regular-font">
          {this.renderRoute('', CreateEventLandingPage)}
          {this.renderRoute('organization-type', OrganizationType)}
          {this.renderRoute('organization-details', OrganizationDetails)}
          {this.renderRoute('role', UserRole)}
          {this.renderRoute('sign-up', SignUp)}
          {this.renderRoute('persona', Persona)}
          {this.renderRoute('athletic-trainer-sign-up', AthleticTrainerSignUp)}
          {this.renderRoute('ready-to-post', NextSteps)}
        </main>
      </div>
    );
  }
}

export default CreateAccountScene;